import React from 'react'
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'
import RadialGauge from '../components/Charts/RadialGauge'
import { useApiData } from '../hooks/useApiData'
import { apiService } from '../services/api'

const RadialGaugePage: React.FC = () => {
  const {
    data: gaugeValue,
    loading,
    error
  } = useApiData(apiService.fetchGaugeData, 50)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box>
      <Typography
        variant={isMobile ? 'h6' : 'h5'}
        gutterBottom
        sx={{
          fontWeight: 600,
          fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
        }}>
        Performance Dashboard
      </Typography>
      <RadialGauge
        value={gaugeValue || 0}
        maxValue={100}
        loading={loading}
        error={error}
      />
    </Box>
  )
}

export default RadialGaugePage
